 <div *ngIf="showLoading" class="loading-overlay">
    <mat-progress-spinner mode="indeterminate" diameter="60"></mat-progress-spinner>
 </div>
